import { SousDispositifLibelle as SousDispositifAFLib } from '@/features/domaine/types/opco/Demande/AF'
import { SousDispositifLibelle as SousDispositifCPROLib } from '@/features/domaine/types/opco/Demande/CPRO'
import { SousDispositifLibelle as SousDispositifFPELib } from '@/features/domaine/types/opco/Demande/CXPI'
import { SousDispositifLibelle as SousDispositifOutilFPELib } from '@/features/domaine/types/opco/Demande/OUTILFPE'
import { SousDispositifLibelle as SousDispositifPROALib } from '@/features/domaine/types/opco/Demande/PROA'

// Todo: INT - A remplacer, dépend du modele et non du dispositif
export const DispositifSousDipositif = {
  AF: SousDispositifAFLib,
  CAPP: null,
  CPRO: SousDispositifCPROLib,
  PROA: SousDispositifPROALib,
  FPE: {
    ...SousDispositifFPELib,
    ...SousDispositifOutilFPELib,
  },
  DR: null,
} as const

type DispositifSousDipositif = typeof DispositifSousDipositif

export const DispositifSousDipositifFormation: Omit<DispositifSousDipositif, 'DR' | 'FPE'> & {
  readonly FPE: typeof SousDispositifFPELib
} = (({ DR, ...autres }) => ({
  ...autres,
  FPE: SousDispositifFPELib,
}))(DispositifSousDipositif)

export const DispositifSousDipositifDr: Omit<DispositifSousDipositif, 'DR' | 'CAPP' | 'FPE'> & {
  readonly FPE: typeof SousDispositifFPELib
} = (({ CAPP, DR, ...autres }) => ({
  ...autres,
  FPE: SousDispositifFPELib,
}))(DispositifSousDipositif)
